import { render, staticRenderFns } from "./GlobalButtons.vue?vue&type=template&id=dcf552ac&scoped=true"
import script from "./GlobalButtons.vue?vue&type=script&lang=js"
export * from "./GlobalButtons.vue?vue&type=script&lang=js"
import style0 from "./GlobalButtons.vue?vue&type=style&index=0&id=dcf552ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf552ac",
  null
  
)

export default component.exports